import PropTypes from 'prop-types';

export const FilterValueType = PropTypes.shape({
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string.isRequired
});

export const FilterBaseType = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    FilterValueType,
    PropTypes.arrayOf(FilterValueType)
  ])
};

export const FilterType = {
  ...FilterBaseType,
  hasChanged: PropTypes.bool,
  isAsync: PropTypes.bool,
  isDate: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isMetric: PropTypes.bool,
  isMulti: PropTypes.bool,
  hasBoolean: PropTypes.bool,
  loadOptions: PropTypes.func,
  onChange: PropTypes.func,
  onBooleanToggle: PropTypes.func,
  options: PropTypes.arrayOf(FilterValueType),
  rollupSupport: PropTypes.array,
  dates: PropTypes.array
};

export const GroupingType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  filters: PropTypes.arrayOf(PropTypes.string).isRequired
});

export const FilterSetType = PropTypes.objectOf(PropTypes.shape(FilterType));
export const GroupingSetType = PropTypes.arrayOf(GroupingType);
